var divider_viewer_rtlignore_default = {
  "divider-container": "kaH1I",
  "divider-container--double": "h-hbU",
  "divider": "ocfWd",
  "divider--single": "fn1Bv",
  "divider--double": "hc9VC",
  "divider--dashed": "Ga0Zg",
  "divider--dotted": "xHlih",
  "divider--small": "Tvp5i",
  "divider--medium": "JAqmM",
  "divider--large": "ULbJt",
  "divider--left": "zsbri",
  "divider--center": "digjW",
  "divider--right": "_8gvFr",
  "svgFixerContainer": "yXqHu",
  "emptyChar": "bfLl5"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
